import * as analyticsManager from "@utils/managers/AnalyticsManager";
import { kAnalyticsConstants } from "@utils/constants/AnalyticsConstants";
import { ReactComponent as CheckMarkSelected } from "@images/check_mark_selected.svg";
import { ReactComponent as PlusIcon } from "@images/plus_icon.svg";
import { DiscoverModel, NLNewsletter } from "@models/Models";

interface OnboardingDiscoverRowProps {
	newsletter: NLNewsletter;
	isChecked: boolean;
	checkOnChange: (newsletter: NLNewsletter) => void;
	itemVisited: () => void;
	previewMessage: (messageId: string) => void;
}

export const OnboardingDiscoverRow = ({ newsletter, isChecked, checkOnChange, itemVisited, previewMessage }: OnboardingDiscoverRowProps) => {
	function rowClicked() {
		analyticsManager.recordEvent(kAnalyticsConstants.Discover.personalisedDiscoverTapped, { newsletter_id: newsletter.id, newsletter_title: newsletter.name, newsletter_index: newsletter.onboarding_sort_index, reference: "onboarding" });
		itemVisited();
		window.open(newsletter.subscribe_link, "_blank");
	}

	if (newsletter.one_click_subscribe_method != null) {
		return (
			<div key={newsletter.id} className="flex flex-col bg-white/10 transition ease-in-out border border-white/20 p-3 rounded-[10px] gap-2 items-start mb-[12px]">
				<div className="flex flex-row justify-between items-center w-full">
					<div className="flex flex-row items-center gap-2 text-left">
						<img src={newsletter.logo} className="w-[50px] h-[50px] rounded-[6px] object-contain border border-white/20" />
						<div className="text-white font-medium font-primary text-xl">{newsletter.name}</div>
					</div>
					{isChecked ? (
						<button className="bg-white w-[30px] h-[30px] rounded-full flex items-center justify-center" onClick={(e) => checkOnChange(newsletter)}>
							<CheckMarkSelected className="w-[29px] h-[29px] ml-[1px] !fill-success-green" />
						</button>
					) : <button className="bg-brand-blue w-[30px] h-[30px] rounded-full flex items-center justify-center hover:scale-105 transition ease-in-out duration-300" onClick={(e) => checkOnChange(newsletter)}>
					<PlusIcon className="w-[16px] h-[16px] ml-[1px] mt-[1px] !fill-white" />
				</button>}
				</div>
				<div className="flex-col">
					<div className="text-force-primary-light/50 font-regular font-primary text-xs text-left">{newsletter.summary}</div>
				</div>
				{newsletter.preview_message_id && <button className="mt-2 w-full border border-force-primary-light/50 rounded-full py-1.5 font-medium font-primary text-xs text-force-primary-light/50 hover:bg-white hover:text-brand-blue transition-background-color duration-300 ease-in-out" onClick={(e) => {
					e.preventDefault();
					previewMessage(newsletter.preview_message_id!)
				}}>PREVIEW</button>}
			</div>
		);
	} else {
		return (
			<div key={newsletter.id} className="flex flex-col bg-white/10 transition ease-in-out border border-white/20 p-3 rounded-[10px] gap-2 items-start mb-[12px]">
				<div className="flex flex-row justify-between items-center w-full">
					<div className="flex flex-row items-center gap-2 text-left">
						<img src={newsletter.logo} className="w-[50px] h-[50px] rounded-[6px] object-contain border border-white/20" />
						<div className="text-white font-medium font-primary text-xl">{newsletter.name}</div>
					</div>
					<button className="bg-white rounded-[10px] px-3 py-2 font-bold font-primary text-xs text-brand-blue hover:scale-105 transition ease-in-out duration-300" onClick={() => rowClicked()}>
						VISIT
					</button>
				</div>
				<div className="flex-col">
					<div className="text-force-primary-light/50 font-regular font-primary text-xs text-left">{newsletter.summary}</div>
				</div>
			</div>
		);
	}
};

export default OnboardingDiscoverRow;
